export const LOVED_BY_IMAGES = [
  'https://production-media.gousto.co.uk/cms/promo-image/Goodfood_x1.jpg',
  'https://production-media.gousto.co.uk/cms/promo-image/Telegraph_x1.jpg',
  'https://production-media.gousto.co.uk/cms/promo-image/Independent_x1.jpg',
  'https://production-media.gousto.co.uk/cms/promo-image/Buzzfeed_x1.jpg',
  'https://production-media.gousto.co.uk/cms/promo-image/Now_x1.jpg',
  'https://production-media.gousto.co.uk/cms/promo-image/Closer_x1.jpg',
]
